import { render, staticRenderFns } from "./CmpTextHtml.vue?vue&type=template&id=5a853476"
import script from "./CmpTextHtml.vue?vue&type=script&lang=js"
export * from "./CmpTextHtml.vue?vue&type=script&lang=js"
import style0 from "./CmpTextHtml.vue?vue&type=style&index=0&id=5a853476&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports